
// import React, { useEffect, useRef, useState, useContext } from "react";
// import {
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend
// } from "recharts";
// import { PrAnalysisApi } from "../../../../../../../../api/Api";
// import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";

// import {
//   Box,
//   Card,
//   CardContent,
//   Grid,
//   Typography,
//   useTheme
// } from "@mui/material";

// // ================== DATE FUNCTION ==================
// export function getDateTimeForDashboardTab1(date = new Date()) {
//   const year = date.getFullYear();
//   const month = date.getMonth(); // 0-based

//   const firstDayOfMonth = new Date(year, month, 1);

//   const formatDate = (d) => d.toISOString().split("T")[0];

//   return {
//     Today: formatDate(date),
//     MonthStart: formatDate(firstDayOfMonth),
//   };
// }

// // ================== COMPONENT ==================
// const Tab4DailyTrend = () => {
//   const chartRef1 = useRef();

//   const { LoggedInUserInfo } = useContext(AuthenticationContext);

//   const { Today, MonthStart } = getDateTimeForDashboardTab1();

//   const [StartDate, setStartDate] = useState(MonthStart);
//   const [EndDate, setEndDate] = useState(Today);

//   const [chartData3, setChartData3] = useState([]);

//   const theme = useTheme();

//   // ================== API CREDENTIALS ==================
//   const credentials = {
//     USER: localStorage.getItem("LoginID") || "",
//     LCODE: localStorage.getItem("LCODE") || "",
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "XYZ",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
//     DT1: StartDate,
//     DT2: EndDate,
//   };

//   // ================== FETCH DATA ==================
//   const fetchLogData = async () => {
//     try {
//       const res = await PrAnalysisApi(credentials);

//       if (res?.data && Array.isArray(res.data)) {
//         const transformedData3 = res.data.map((item) => ({
//           name: item.DATET || "N/A",
//           ENG: parseFloat(item.ENG) || 0,
//           CUF: parseFloat(item.CUF) || 0,
//         }));

//         setChartData3(transformedData3);
//       } else {
//         setChartData3([]);
//       }
//     } catch (error) {
//       setChartData3([]);
//     }
//   };

//   // ================== LOAD ON MOUNT ==================
//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   // ================== REFRESH ==================
//   const onRefreshData = () => {
//     if (StartDate && EndDate) {
//       fetchLogData();
//     } else {
//       alert("Please provide valid dates");
//     }
//   };

//   // ================== UI ==================
//   return (
//     <Box>
//       <Grid container>
//         <Grid item xs={12}>
          
//             <CardContent ref={chartRef1}>
//               {chartData3.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={150}>
//                   <ComposedChart data={chartData3}>
//                     <CartesianGrid strokeDasharray="3 3" />

//                     <XAxis dataKey="name" />

//                     <YAxis
//                       yAxisId="left"
//                       label={{
//                         value: "ENG",
//                         angle: -90,
//                         position: "insideLeft",
//                       }}
//                     />

//                     <Tooltip />

//                     <Legend
//                       layout="horizontal"
//                       verticalAlign="top"
//                       align="center"
//                       wrapperStyle={{
//                         paddingBottom: "1px",
//                         fontSize: "12px",
//                       }}
//                     />

//                     <Bar
//                       dataKey="ENG"
//                       name="Energy Generation"
//                       fill={LoggedInUserInfo?.dash_color || theme.palette.primary.main}
//                       yAxisId="left"
//                     >
//                       <LabelList
//                         dataKey="ENG"
//                         position="top"
//                         style={{
//                           fill: LoggedInUserInfo?.dash_color || theme.palette.primary.main,
//                           fontSize: "12px",
//                           fontWeight: "bold",
//                         }}
//                       />
//                     </Bar>
//                   </ComposedChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <Typography
//                   variant="body1"
//                   color="textSecondary"
//                   textAlign="center"
//                 >
//                   No data available for the selected range.
//                 </Typography>
//               )}
//             </CardContent>
          
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default Tab4DailyTrend;


import React, { useEffect, useRef, useState, useContext } from "react";
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  Legend
} from "recharts";
import { PrAnalysisApi } from "../../../../../../../../api/Api";
import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";

import {
  Box,
  CardContent,
  Grid,
  Typography,
  useTheme
} from "@mui/material";

// ================== DATE FUNCTION ==================
export function getDateTimeForDashboardTab1(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth(); // 0-based

  const firstDayOfMonth = new Date(year, month, 1);

  const formatDate = (d) => d.toISOString().split("T")[0];

  return {
    Today: formatDate(date),
    MonthStart: formatDate(firstDayOfMonth),
  };
}

// ================== COMPONENT ==================
const Tab4DailyTrend = () => {
  const chartRef1 = useRef();

  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const theme = useTheme();

  const { Today, MonthStart } = getDateTimeForDashboardTab1();

  const [StartDate, setStartDate] = useState(MonthStart);
  const [EndDate, setEndDate] = useState(Today);

  const [chartData3, setChartData3] = useState([]);

  // ================== API CREDENTIALS ==================
  const credentials = {
    USER: localStorage.getItem("LoginID") || "",
    LCODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "XYZ",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
    DT1: StartDate,
    DT2: EndDate,
  };

  // ================== FETCH DATA ==================
  const fetchLogData = async () => {
    try {
      const res = await PrAnalysisApi(credentials);

      if (res?.data && Array.isArray(res.data)) {
        const transformedData = res.data.map((item) => ({
          name: item.DATET || "N/A",
          ENG: Number(item.ENG) || 0,
        }));

        setChartData3(transformedData);
      } else {
        setChartData3([]);
      }
    } catch (error) {
      setChartData3([]);
    }
  };

  // ================== LOAD ON MOUNT ==================
  useEffect(() => {
    fetchLogData();
  }, []);

  // ================== UI ==================
  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          <CardContent ref={chartRef1}>
            {chartData3.length > 0 ? (
              <ResponsiveContainer width="100%" height={150}>
                <ComposedChart data={chartData3}>
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="name" />

                  <YAxis
                    yAxisId="left"
                    label={{
                      value: "ENG",
                      angle: -90,
                      position: "insideLeft",
                    }}
                  />

                  <Tooltip />

                  <Legend
                    layout="horizontal"
                    verticalAlign="top"
                    align="center"
                    wrapperStyle={{
                      paddingBottom: "2px",
                      fontSize: "12px",
                    }}
                  />

                  <Bar
                    dataKey="ENG"
                    name="Energy Generation"
                    yAxisId="left"
                    fill={
                      LoggedInUserInfo?.dash_color ||
                      theme.palette.primary.main
                    }
                  />
                </ComposedChart>
              </ResponsiveContainer>
            ) : (
              <Typography
                variant="body2"
                color="textSecondary"
                textAlign="center"
              >
                No data available for the selected range.
              </Typography>
            )}
          </CardContent>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Tab4DailyTrend;
